function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import { space } from 'styled-system';
import { useSpring } from '@react-spring/web';
import { DateTime } from 'luxon';
export { default as shouldForwardProp } from '@styled-system/should-forward-prop';
export { useIsOpen } from './useIsOpen';
export { useOutsideClick } from './useOutsideClick';
export * from './scrollToRef';
export var dateObjectToFormat = function dateObjectToFormat(day) {
  return DateTime.fromJSDate(day, {
    zone: 'Etc/UTC'
  }).toFormat('LL/dd/yyyy');
};
/**
 * Higher-Order-Component
 * use this to leave a warning to developers who try to use a deprecated component
 *
 * ex: `export default deprecate('please use `Flex` instead')(Flexbox);`
 */

export var deprecate = function deprecate(message) {
  return function (WrappedComponent) {
    var _class;

    return _class = /*#__PURE__*/function (_React$Component) {
      _inherits(Deprecated, _React$Component);

      var _super = _createSuper(Deprecated);

      function Deprecated() {
        _classCallCheck(this, Deprecated);

        return _super.apply(this, arguments);
      }

      _createClass(Deprecated, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          console.warn('Deprecated:', message);
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(WrappedComponent, this.props);
        }
      }]);

      return Deprecated;
    }(React.Component), _class.displayName = "deprecated(".concat(getDisplayName(WrappedComponent), ")"), _class;
  };
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var omit = function omit(obj, blackListedKeys) {
  return Object.entries(obj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return !blackListedKeys.includes(key);
  }).reduce(function (obj, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        val = _ref4[1];

    return Object.assign(obj, _defineProperty({}, key, val));
  }, {});
}; // we definitely don't want objects making their way into the DOM as attributes


export var withoutObjects = function withoutObjects(props) {
  return Object.keys(props).filter(function (propKey) {
    if (propKey === 'children') return true;
    if (!propKey || !props[propKey]) return true;
    return props[propKey].toString() !== '[object Object]';
  }).reduce(function (acc, curr) {
    return Object.assign(acc, _defineProperty({}, curr, props[curr]));
  }, {});
}; // https://github.com/styled-components/styled-components/issues/135

export var withPropsFilter = function withPropsFilter(Tag) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/React.memo(function (props) {
    return /*#__PURE__*/React.createElement(Tag, withoutObjects(omit(props, filter)));
  });
};
var blacklistedSpaceKeys = {
  padding: true,
  paddingTop: true,
  paddingRight: true,
  paddingBottom: true,
  paddingLeft: true,
  margin: true,
  marginTop: true,
  marginRight: true,
  marginBottom: true,
  marginLeft: true
};
export function strictSpace(props) {
  props.mt = props.my !== undefined ? props.my : props.mt;
  props.mb = props.my !== undefined ? props.my : props.mb;
  props.ml = props.mx !== undefined ? props.mx : props.ml;
  props.mr = props.mx !== undefined ? props.mx : props.mr;
  props.pt = props.py !== undefined ? props.py : props.pt;
  props.pb = props.py !== undefined ? props.py : props.pb;
  props.pl = props.px !== undefined ? props.px : props.pl;
  props.pr = props.px !== undefined ? props.px : props.pr;
  var whitelistedProps = Object.keys(props).reduce(function (acc, curr) {
    if (blacklistedSpaceKeys[curr] !== undefined) return acc;
    acc[curr] = props[curr];
    return acc;
  }, {});
  return space(whitelistedProps);
}
Object.keys(space).forEach(function (key) {
  if (!blacklistedSpaceKeys[key]) strictSpace[key] = space[key];
});
/**
 * Use this wrapper hook instead of useSpring from react-spring
 * to make sure that your spring animations have velocity,
 * even when parts of the animation have been delegated to other means of control
 * (e.g. gestures)
 */

var getTrackedVar = function getTrackedVar(_trackedVar, initialConfig) {
  if (_trackedVar) return _trackedVar;
  var hasX = initialConfig.x !== undefined;
  var hasY = initialConfig.y !== undefined;

  if (hasX && hasY || !hasX && !hasY) {
    throw new Error("[useVelocityTrackedSpring] can't automatically detect which variable to track, so you need to specify which variable should be tracked in the second argument");
  }

  return hasX ? 'x' : 'y';
};

export var useVelocityTrackedSpring = function useVelocityTrackedSpring(initialConfigFunc, _trackedVar) {
  var initialConfig = initialConfigFunc();
  var trackedVar = getTrackedVar(_trackedVar, initialConfig);

  var _useSpring = useSpring(initialConfigFunc),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      springVals = _useSpring2[0],
      api = _useSpring2[1];

  var _useSpring3 = useSpring(function () {
    return _objectSpread({
      velocityTracker: initialConfig[trackedVar]
    }, initialConfig);
  }),
      _useSpring4 = _slicedToArray(_useSpring3, 2),
      velocityTracker = _useSpring4[0].velocityTracker,
      velocityTrackerApi = _useSpring4[1]; // you can disable the tracking or setting of velocity by providing options in the second argument


  var wrappedSet = function wrappedSet(data) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        skipTrackVelocity = _ref5.skipTrackVelocity,
        skipSetVelocity = _ref5.skipSetVelocity;

    // update velocity tracker
    var velocityTrackerArgs = {
      config: data.config
    };
    if (data[trackedVar] && !skipTrackVelocity) velocityTrackerArgs.velocityTracker = data[trackedVar];
    velocityTrackerApi.start(velocityTrackerArgs); // update actual spring

    if (data.immediate) return api.start(data);
    api.start(_objectSpread(_objectSpread({}, data), {}, {
      config: _objectSpread(_objectSpread({}, data.config), {}, {
        velocity: !skipSetVelocity && velocityTracker.lastVelocity
      })
    }));
  };

  return [springVals, wrappedSet];
};